<template>
  <div class="navbar">
    <nav>
      <img src="@/assets/sound.png" alt="" @click.prevent="$router.push('/')">
      <h1><router-link :to="{ name: 'Home' }">Lofi Chill</router-link></h1>
      <div class="link">
        <div v-if="user">
          <a href="#" v-if="dropDown" class="dropdown">Playlists
            <div class="dropdown-block">
              <router-link :to="{ name: 'Createplaylist'}">Create Playlist</router-link>
              <router-link :to="{ name: 'Userplaylist'}">My Playlist</router-link>
            </div>
          </a>
          <div v-if="!dropDown">
            <router-link :to="{ name: 'Createplaylist'}">Create Playlist</router-link>
            <router-link :to="{ name: 'Userplaylist'}">My Playlist</router-link>
          </div>
          <span>Hi {{ user.displayName }}</span>
          <span class="photo"><img v-if="URL" :src="URL" alt=""></span>
          <button class="logout" @click.prevent="handleOut">Log Out</button>
        </div>
        <div v-else>
          <router-link :to="{ name: 'Login'}">Log In</router-link>
          <router-link :to="{ name: 'Signup'}">Sign Up</router-link>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { projectAuth }from '../firebase/config'
import useLogout from '../composables/useLogout'
import getUser from '../composables/getUser'
import { useRouter } from 'vue-router'
import { ref, watch, watchEffect } from 'vue'
export default {
  setup () {
    const { logout } = useLogout();
    const { user } = getUser();
    const URL = ref(null);
    const dropDown = ref(false);
    const router = useRouter();
    const handleOut = async () => {
      await logout();
      router.push({ name: 'Login'});
    }
    if(user.value) {
      URL.value = projectAuth.currentUser.photoURL;
      watchEffect(() => {
      URL.value = projectAuth.currentUser.photoURL;
    });
    }
    const measuresize = () => {
      const width = window.innerWidth;
      if(width <= 576) {
        dropDown.value = true;
      } else {
        dropDown.value = false;
      }
    };
    return { handleOut, user, URL, measuresize, dropDown }
  },
  created () {
    window.addEventListener('resize', this.measuresize);
    this.measuresize();
  }
}
</script>

<style scoped>
  .navbar {
    padding: 16px 10px;
    margin-bottom: 60px;
    background: white;
  }
  nav {
    display: flex;
    max-width: 1200px;
    align-items: center;
    margin: 0 auto;
  }
  nav img {
    max-height: 60px;
  }
  nav h1 {
    margin-left: 20px;
  }
  nav .link {
    margin-left: auto;
  }
  nav .link>div {
    display: flex;
    align-items: center;
  }
  nav .link a, button {
    margin-left: 16px;
    font-size: 14px;
  }
  nav .link .logout {
    margin-top: 0;
  }
  span {
    font-size: 14px;
    display: inline-block;
    margin-left: 16px;
    padding-left: 16px;
    border-left: 1px solid #eee;
  }
  span.photo {
    border: none;
    padding-left: 0px;
  }
  span.photo > img {
    width: 32px;
    height: 32px;
    object-position: center center;
    object-fit: cover;
    border-radius: 50%;
    vertical-align: bottom;
  }
@media only screen and (max-width: 615px) {
  nav img {
    max-height: 35px;
  }
  nav h1 {
    margin-left: 12px;
    font-size: 1.4rem;
  }
  nav .link a, button {
    margin-left: 10px;
    font-size: 13px;
  }
  span {
    font-size: 13px;
    margin-left: 10px;
    padding-left: 10px;
  }
  .logout {
    padding: 5px 9px;
    font-size: 13px;
  }
  nav .dropdown {
    display: inline-block;
    position: relative;
  }
  nav .dropdown-block,
  nav .dropdown-block:visited {
    position: absolute;
    top: 3rem;
    left: 0;
    width: 8rem;
    display: flex;
    flex-direction: column;
    background-color: #eee;
    transition: all .4s;
    visibility: hidden;
    opacity: 0;
  }
  nav .dropdown:focus .dropdown-block {
    top: 100%;
    visibility: visible;
    opacity: 1;
  }
  nav .dropdown-block a {
    display: block;
    padding: 12px 8px;
  }
  nav .dropdown-block a:focus{
    background-color: rgb(201, 199, 199);

  }
}
@media only screen and (max-width: 430px) {
  nav img {
    max-height: 30px;
  }
    nav h1 {
      margin-left: 10px;
      font-size: 1.2rem;
    }
}
</style>
